import React from 'react';

const EmptyState = ({ icon, title, description, buttonText, onAction, simple = false }) => {
    // If 'simple' is true, return a more compact version (e.g. for mobile or smaller boxes)
    if (simple) {
        return (
            <div className="flex flex-col items-center justify-center py-10 px-4 text-center">
                <div className="w-16 h-16 rounded-full bg-teal/5 dark:bg-cyan/5 border border-teal/10 dark:border-cyan/10 flex items-center justify-center mb-4 relative group hover:border-teal/30 dark:hover:border-cyan/30 transition-all">
                    <div className="absolute inset-0 bg-primary/10 dark:bg-cyan/10 rounded-full blur-md group-hover:blur-lg transition-all"></div>
                    <span className="material-symbols-outlined text-primary dark:text-cyan text-3xl relative z-10 opacity-90 drop-shadow-sm">
                        {icon || 'inbox'}
                    </span>
                </div>
                <h4 className="text-lg font-bold text-darkTeal dark:text-light mb-1">{title}</h4>
                <p className="text-sm text-darkTeal/60 dark:text-light/60 mb-5 max-w-[240px] leading-relaxed">{description}</p>
                {buttonText && onAction && (
                    <button
                        onClick={onAction}
                        className="text-xs font-black uppercase tracking-wider px-5 py-2.5 rounded-lg transition-all bg-primary/10 text-primary border border-primary/20 hover:bg-primary/20 dark:bg-cyan/10 dark:text-cyan dark:border-cyan/20 dark:hover:bg-cyan/20 flex items-center gap-2 shadow-sm"
                    >
                        <span className="material-symbols-outlined text-[16px]">add_circle</span>
                        {buttonText}
                    </button>
                )}
            </div>
        );
    }

    return (
        <div className="flex flex-col items-center justify-center py-16 px-6 text-center w-full relative overflow-hidden group">
            {/* Background decorative flares */}
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-64 h-64 bg-primary/5 dark:bg-cyan/5 rounded-full blur-3xl group-hover:bg-primary/10 dark:group-hover:bg-cyan/10 transition-colors duration-1000 pointer-events-none"></div>

            {/* Premium Icon Container */}
            <div className="relative mb-8 z-10">
                {/* Outer Dashed ring */}
                <div className="absolute -inset-4 border border-dashed border-teal/30 dark:border-cyan/30 rounded-full animate-[spin_30s_linear_infinite] opacity-60"></div>
                {/* Inner Glowing ring */}
                <div className="absolute inset-0 bg-gradient-to-tr from-primary/30 to-teal-400/20 dark:from-cyan/30 dark:to-blue-500/20 rounded-full blur-xl"></div>
                {/* Main Icon Circle */}
                <div className="relative w-24 h-24 rounded-full bg-white dark:bg-navy border border-teal/20 dark:border-white/10 shadow-xl shadow-primary/10 dark:shadow-cyan/10 flex items-center justify-center overflow-hidden">
                    {/* Glass reflection */}
                    <div className="absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/60 to-transparent dark:from-white/10 opacity-60 pointer-events-none"></div>
                    <span className="material-symbols-outlined text-primary dark:text-cyan text-5xl transform group-hover:scale-110 transition-transform duration-500 drop-shadow-[0_0_12px_rgba(37,176,155,0.4)] dark:drop-shadow-[0_0_12px_rgba(8,217,214,0.4)]">
                        {icon || 'inbox'}
                    </span>
                </div>
            </div>

            <h3 className="text-2xl md:text-3xl font-black text-darkTeal dark:text-light mb-3 tracking-tight relative z-10">
                {title}
            </h3>

            <p className="text-sm md:text-base text-darkTeal/70 dark:text-light/60 max-w-lg mb-8 leading-relaxed relative z-10">
                {description}
            </p>

            {buttonText && onAction && (
                <button
                    onClick={onAction}
                    className="relative z-10 flex items-center gap-2 px-8 py-3.5 bg-primary dark:bg-cyan hover:bg-primary/90 dark:hover:bg-cyan/90 text-white dark:text-navy font-black text-sm uppercase tracking-widest rounded-xl transition-all shadow-lg shadow-primary/30 dark:shadow-cyan/30 hover:shadow-primary/50 dark:hover:shadow-cyan/50 hover:-translate-y-0.5 border border-white/10"
                >
                    <span className="material-symbols-outlined text-[20px]">add_circle</span>
                    {buttonText}
                </button>
            )}
        </div>
    );
};

export default EmptyState;
